import React, { useState } from "react";
import { Datagrid, DateField, RaRecord, TextField, useRefresh, useListContext } from "react-admin";
import CoreEditButton from "../../../../shared/components/core/CoreEditButton";
import CustomButton from "../../../../shared/components/core/CustomButton";
import SendIcon from '@mui/icons-material/Send';
import CoreShowButton from "../../../../shared/components/core/CoreShowButton";
import sacopModules from "../../../../shared/utilities/sacopModules";
import { Sacop } from "../../../../shared/types/types";
import fetchs from "../../../../shared/utilities/fetchs";

interface MobileGridProps {
    data? : RaRecord[];
}

const MobileGrid = (props: MobileGridProps) => {
    const refresh = useRefresh();
    const { data } = useListContext<Sacop>();
    const [sentIds, setSentIds] = useState<number[]>([]);

    const handleButtonClick = (record: Sacop) => {
        const { sendSacopToResponsibleForClosing } = fetchs();

        return sendSacopToResponsibleForClosing(record.id)
            .then((data) => {
                setSentIds(prev => [...prev, record.id]);
                refresh();
            });
    };

    const filteredData = data ? data.filter(item => !sentIds.includes(item.id)) : [];

    return (
        <Datagrid data={filteredData} bulkActionButtons={false}>
            <TextField source="id" label="resources.sacop.fields.id"  variant="body1" />
            <TextField source="motive.motiveName" label="resources.sacop.fields.motive.motiveName" variant="body1" sortable={false} />
            <DateField source="dateRequestAction" label="resources.sacop.fields.dateRequestAction" variant="body1" />
            <DateField source="expirationDateAction" label="resources.sacop.fields.expirationDateAction" variant="body1" />
            <TextField source="closingStatus.statusName" label="resources.sacop.fields.actionStatus" variant="body1" sortable={false}/>
            <TextField source="verificationStatus.statusName" label="resources.sacop.fields.verificationStatus" variant="body1" sortable={false}/>

            <CoreEditButton permission="BACKOFFICE_IMPLEMENTATION_OF_ACTION_U" actionModule={sacopModules.IMPLEMENTATIONFORACTION} />
            <CoreShowButton permission="BACKOFFICE_IMPLEMENTATION_OF_ACTION_L" />
            <CustomButton  title="Enviar" icon={<SendIcon />} onClick={handleButtonClick} action={sacopModules.IMPLEMENTATIONFORACTION} />
        </Datagrid>
    );
}



export default MobileGrid;